import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import Notice, { SignatureType } from "./notice";
import { czechID } from "config";

export const defaultExemptionReason = undefined;
export const foreignExemptionReasons = ["O1", "O2"];

export const NoticePowerOfAttorneyRules: EntityValidationRules<Notice> = {
  _powerOfAttorneyFilesBase64: {
    requiredIf: {
      condition: (entity: Notice) =>
        !!(
          entity._signatureType === SignatureType.DataBox &&
          ((entity.vehicleOperator &&
            entity.vehicleOperator.naturalPerson &&
            entity.vehicleOperator.naturalPerson.isRepresentedByProxy) ||
            (entity.vehicleOperator && entity.vehicleOperator.isLegalPerson))
        ),
      customMessage: "documentUploadRequired",
    },
  },
};

export const NoticeTechnicalLicenseRules: EntityValidationRules<Notice> = {
  _technicalLicenseFilesBase64: {
    requiredIf: {
      condition: (entity: Notice) => entity._signatureType === SignatureType.DataBox && entity.vehicle?.countryId !== czechID,
      customMessage: "documentUploadRequired",
    },
  },
};

export default class Exemption extends Notice {
  @observable
  exemptionReasonId?: string = defaultExemptionReason;

  @computed
  get rules(): EntityValidationRules<Exemption> {
    return {
      exemptionReasonId: {
        required: true,
      },
    };
  }
}
